import React from 'react'
import {Outlet} from 'react-router-dom'

import {RequireNoAuth} from '@/lib/auth'

const NoAuthLayout = () => <RequireNoAuth children={<Outlet />} />

export default NoAuthLayout
